import apiSlice from "./ApiSlice";

export const chapterApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL
    getAllChapters: builder.query({
      providesTags: ["chapters"],
      query: () => {
        return {
          url: "/chapter",
          method: "GET",
        };
      },
    }),
    // GET ALL CHAPTER WITH PAGINATION
    getAllChapterWithPagination: builder.query({
      providesTags: ["chapters"],
      query: (body) => {
        return {
          url: "/chapter/",
          method: "POST",
          body,
        };
      },
    }),
    // Add
    addChapter: builder.mutation({
      invalidatesTags: ["chapters"],
      query: (body) => {
        return {
          url: "/chapter/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteChapter: builder.mutation({
      invalidatesTags:["chapters"],
      query: ({ id }) => {
        return {
          url: `/chapter/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET CHAPTER BY ID
    getChapterById: builder.query({
      providesTags: ["chapters"],
      query: ({id}) => {
        return {
          url: `/chapter/${id}`,
          method: 'GET',
        };
      },
    }),
    // EDIT
    editChapter: builder.mutation({
      invalidatesTags:["chapters"],
      query: ({body,id}) => {
        return {
          url: `/chapter/${id}`,
          method: 'PUT',
          body,
        };
      },
    }),
    getModulesChapter: builder.query({
      providesTags: ["module" , "chapters"],
       query: (id:any) => {
        return {
          url: `/chapter/module/${id}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetAllChaptersQuery,
  useGetAllChapterWithPaginationQuery,
  useAddChapterMutation,
  useDeleteChapterMutation,
  useGetChapterByIdQuery,
  useEditChapterMutation ,
  useGetModulesChapterQuery
} = chapterApi;
